const buttons = document.querySelectorAll('[data-show-password]');

const defaultOptions = {
  targetSelector: 'input',
  event: 'click'
}

buttons.forEach(button => {
  let options = defaultOptions;
  if (button.dataset.showPassword) {
	options = { ...defaultOptions, ...JSON.parse(button.dataset.showPassword) };
  }

  let target = button.parentElement.querySelector(options.targetSelector);
  if (!target) {
	return;
  }
  switch (options.event) {
	case 'hover':
	  button.addEventListener('mouseenter', function (e) {
		target.type = 'text';
	  });
	  button.addEventListener('mouseleave', function (e) {
		target.type = 'password';
	  });
	  break;
	case 'click':
	  button.addEventListener('click', function (e) {
		if (target.type === 'text')
		  target.type = 'password';
		else
		  target.type = 'text';
	  });
	  break;
  }
});